import {
  Slice,
  CreateSliceOptions,
  SliceCaseReducers,
  PayloadAction,
  createSlice,
  createAction,
  ActionReducerMapBuilder,
} from '@reduxjs/toolkit';

export declare type NoInfer<T> = [T][T extends any ? 0 : never];

export type resetStorePayload =
  | {
      ignoreResetForSlices: string[];
    }
  | undefined;

export const resetStore = createAction<resetStorePayload>('reset');

export function createExtendedSlice<
  State,
  CR extends SliceCaseReducers<State>,
  Name extends string = string,
>(options: CreateSliceOptions<State, CR, Name>): Slice<State, CR, Name> {
  const { initialState, name, reducers, extraReducers } = options;

  // eslint-disable-next-line no-restricted-syntax
  const slice = createSlice({
    initialState,
    name,
    reducers,
    extraReducers: (builder: ActionReducerMapBuilder<NoInfer<State>>) => {
      // @ts-ignore
      builder.addCase(
        resetStore,
        (_, action: PayloadAction<resetStorePayload>) => {
          const { ignoreResetForSlices = [] } = action.payload || {};
          // Reset the state to the initial state
          if (!ignoreResetForSlices.includes(name)) {
            return initialState;
          }
        },
      );

      if (typeof extraReducers === 'function') {
        extraReducers(builder);
      }
    },
  });

  return slice;
}
